module.exports = __webpack_public_path__ + "img/factoryplay_hinchables_diversion.fda5a60a.png";